// <zzy-toast> + window.zzyToast(message, kind)
class ZzyToast extends HTMLElement {
  connectedCallback() {
    if (window.__zzyToastReady) return;
    window.__zzyToastReady = true;
    const host = document.createElement('div');
    host.id = '__zzy_toast_host';
    host.style.cssText = 'position:fixed;top:24px;right:24px;display:flex;flex-direction:column;gap:10px;z-index:9999;pointer-events:none';
    document.body.appendChild(host);

    window.zzyToast = (msg, kind = 'info') => {
      const palette = {
        info:    'var(--zzy-info)',
        success: 'var(--zzy-success)',
        warning: 'var(--zzy-warning)',
        danger:  'var(--zzy-danger)'
      };
      const c = palette[kind] || palette.info;
      const el = document.createElement('div');
      el.style.cssText = `
        background: var(--zzy-surface);
        border-left: 3px solid ${c};
        color: var(--zzy-text);
        padding: 12px 18px;
        border-radius: 6px;
        box-shadow: var(--zzy-shadow);
        font: 500 13px/1.4 var(--zzy-font);
        min-width: 220px;
        pointer-events:auto;
        opacity: 0;
        transform: translateX(20px);
        transition: opacity .25s, transform .25s;
      `;
      el.textContent = msg;
      host.appendChild(el);
      requestAnimationFrame(() => { el.style.opacity = '1'; el.style.transform = 'translateX(0)'; });
      setTimeout(() => { el.style.opacity = '0'; el.style.transform = 'translateX(20px)'; setTimeout(() => el.remove(), 300); }, 4500);
    };
  }
}
customElements.define('zzy-toast', ZzyToast);
